<section class="theme_bg" for="ModifySearch">
    <div class="container" *ngIf="mobileModify">
        <div class="row bg-white py-2 rounded black_bg">
            <div class="col-md-10 col-7">
                <div class="row font-weight-bold">
                    <div class="col-md-4 text-white">City</div>
                    
                </div>
                <div  class="row">
                    <div class="col-md-12 col-12 text-white">
                        {{cityData}}
                    </div>
                </div>
    
            </div>

            <div class="col-md-2 col-5">
                <button type="button" class="btn btn-success btn-lg pull-right btn_hover btn_flight"
                    (click)="isCollapsedSearch = !isCollapsedSearch" [attr.aria-expanded]="!isCollapsedSearch"
                    aria-controls="collapseBasic">
                    Change Hotel
                </button>
            </div>
           
        </div>
    </div>

    <div class="container nopad">
        <div class="row mobile_row bbottom">
            <div class="col-md-12 col-lg-12 p-0">
                <div id="collapseBasic" *ngIf="isCollapsedSearch" style="z-index: 9999; margin-top: 10px;">
                    <div class="">
                        <div class="col-md-12">
                            <!-- <div class="tabs_wrapper">
                                <div class="tabs_section">
                                    <ul class="nav nav-tabs moduletabs" id="myTab" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home"
                                                role="tab" aria-controls="home" aria-selected="true">Flight</a>
                                        </li>
                                    </ul>
                                </div>
                            </div> -->
                            <div class="tab-content searchtabs" id="myTabContent">
                                <div class="tab-pane fade show active" id="home" role="tabpanel"
                                    aria-labelledby="home-tab">
                                    <app-hotel-search></app-hotel-search>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="clearfix"></div>
<section for="HotelFoundAndListSearchedResult" class="loading-container theme_bg"> 
    <div class="container">
        <div class="row mobile_row ">
            <div class="col-md-3 col-lg-3 nopad mobile_nopad filter_row" *ngIf="showMobilefilter">
                <div class="flteboxwrp">
                    <div class="fltrboxin rounded-bottom">
                        <div class="celsrch">
                            <div>
                                <a (click)="resetFilter()" class="pull-right" style="cursor: pointer;"
                                    id="reset_filters">Reset
                                    All</a>

                                    <a (click)="closeFilter()" class="pull-right closefilter" style="cursor: pointer;">Close</a>
                            </div>
                            &nbsp;  &nbsp;
                            <!-- <div *ngIf="selectedHotel" #mapContainer id="map1" style="width: 100%; height:250px;"></div> -->
                            <app-filter-hotels></app-filter-hotels>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-9 col-lg-9 mobile_nopad">
                <app-sorting-hotels></app-sorting-hotels>
                <div class="row" style="margin-top: 20px;">
                    <div class="col-md-12 col-lg-12">
                        <span class="showMobilefilterbtn" (click)="mobileFilter()"><i class="fal fa-filter"></i></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-12 pr-0">
                        <!-- <app-sorting></app-sorting> -->
                    </div>
                </div>
                <div *ngIf="hotels.length > 0" class="col-md-12 col-lg-12 mb-2 mob_hide">
                    <div class="row">
                        <div class="col-md-6 nopad wht_clr"><span class="filterSpan"><strong>{{hotels.length}}</strong> Hotels Found</span></div>

                        <div class="col-md-6 nopad text-right wht_clr">All taxes and fees included, except local tax if
                            applicable.</div>
                    </div>
                </div>
                <div *ngIf="hotels.length > 0" class="row">
                    <div class="col-md-12 col-lg-12">
                        <div *ngFor="let hotel of hotels; let i = index;" class="card mb-4 rounded result_hotel nopad">
                            <div class="card-body nopad">
                                <div class="row text-center">
                                    <div class="col-md-4" *ngIf="hotel.HotelPicture; else noPhoto">
                                        <img class="rounded imgStyle" [src]="hotel.HotelPicture" alt="">
                                    </div>
                                    <ng-template #noPhoto>
                                        <div class="col-md-4">
                                            <img class="rounded imgStyle" src="assets/images/originals/buildings.jpg"
                                                alt="">
                                        </div>
                                    </ng-template>
                                    <div class="col-md-8 mb-2 pb-0 row mobile_row" style="padding: 8px;">
                                        <div class="col-md-8" style="text-align: left;">
                                            <h5 class="cusromGrey">
                                                <strong>{{hotel.HotelName}}</strong>
                                            </h5>
                                            <ng-template *ngIf="hotel.StarRating === 0 then noStar; else stars">
                                            </ng-template>
                                            <ng-template #noStar>
                                                <span class="star_rtng">
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                    <i class="fas fa-star"></i>
                                                </span>
                                            </ng-template>
                                            <ng-template #stars>
                                                <span class="star_rtng">
                                                    <i class="fas fa-star star_rtng_clr"
                                                        *ngFor="let s of hotel.StarRating | map: getStarArray"></i>
                                                    <i class="fas fa-star"
                                                        *ngFor="let s of hotel.StarRating | map: getStarArrayRemaining"></i>
                                                </span>
                                            </ng-template>
                                            <p class="address_loc">
                                                <i class="fal fa-map-marker-alt"></i> {{hotel.HotelAddress}} - <a data-toggle="modal" data-target="#mapview" (click)="initializeMap(hotel)">View On Map</a>
                                            </p>
                                            &nbsp;
                                            <div>
                                                <p>
                                                    <i class="fa fa-utensils" style="color: #a3a3a3; margin-right: 5px;"></i>
                                                    {{hotel.RoomDetails[0]?.rates[0]?.boardName}} 
                                                    
                                                    <i class="fa fa-bed" style="color: #a3a3a3; margin-left: 10px; margin-right: 5px;"></i>
                                                    {{hotel.RoomDetails[0]?.name}}
                                                  </p>                                                  
                                            </div>
                                            <!-- <p class="address_loc">
                                                {{hotel.HotelAddress}}
                                            </p> -->
                                            <!-- <span class="g_fmil">Great for Families</span> -->
                                            <div class="clearfix"></div>
                                            <!-- <div class="row">
                                                <div class="col-md-6 col-6"><span class="c_fmil">Cleaniness 4.0/5</span>
                                                </div>
                                                <div class="col-md-6 col-6"><span class="c_fmil">Location 4.0/5</span>
                                                </div>
                                            </div> --> 
                                            <div class="mob_hide">
                                                <br><br>
                                                <div class="col-md-12 text-left nopad"
                                                    *ngIf="hotel.HotelAmenities?.length > 0; else noAmenity">
                                                    <i class="fas fa-swimming-pool cusromGrey p-2"
                                                        tooltip="Swimming Pool"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'pool')">
                                                    </i>
                                                    <i class="fas fa-utensils cusromGrey p-2" tooltip="Restaurant"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'restaurant')">
                                                    </i>
                                                    <i class="fa fa-glass cusromGrey p-2" tooltip="Bar"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'bar')">
                                                    </i>
                                                    <i class="fas fa-umbrella-beach cusromGrey p-2"
                                                        tooltip="Private Beach"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'private beach')">
                                                    </i>
                                                    <i class="fas fa-business-time cusromGrey p-2"
                                                        tooltip="Business installations"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'Business installations')">
                                                    </i>
                                                    <i class="fas fa-child cusromGrey p-2" tooltip="Children amenities"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'Children amenities')">
                                                    </i>
                                                    <i class="fas fa-spa cusromGrey p-2" tooltip="Health and Spa"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'Health and Spa')">
                                                    </i>
                                                    <i class="fas fa-wifi cusromGrey p-2" tooltip="Wi-fi"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'Wi-fi')">
                                                    </i>
                                                    <i class="fas fa-parking cusromGrey p-2" tooltip="Car park"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'Car park')">
                                                    </i>
                                                    <i class="fas fa-garage cusromGrey p-2" tooltip="Garage"
                                                        *ngIf="hasAmenities(hotel.HotelAmenities, 'Garage')">
                                                    </i>
                                                </div>
                                            </div>

                                            <div class="col-md-12 text-left mob_show nopad"
                                                *ngIf="hotel.HotelAmenities?.length > 0">
                                                <i class="fas fa-swimming-pool cusromGrey p-2" tooltip="Swimming Pool"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'pool')">
                                                </i>
                                                <i class="fas fa-utensils cusromGrey p-2" tooltip="Restaurant"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'restaurant')">
                                                </i>
                                                <i class="fa fa-glass cusromGrey p-2" tooltip="Bar"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'bar')">
                                                </i>
                                                <i class="fas fa-umbrella-beach cusromGrey p-2" tooltip="Private Beach"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'private beach')">
                                                </i>
                                                <i class="fas fa-business-time cusromGrey p-2"
                                                    tooltip="Business installations"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'Business installations')">
                                                </i>
                                                <i class="fas fa-child cusromGrey p-2" tooltip="Children amenities"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'Children amenities')">
                                                </i>
                                                <i class="fas fa-spa cusromGrey p-2" tooltip="Health and Spa"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'Health and Spa')">
                                                </i>
                                                <i class="fas fa-wifi cusromGrey p-2" tooltip="Wi-fi"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'Wi-fi')">
                                                </i>
                                                <i class="fas fa-parking cusromGrey p-2" tooltip="Car park"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'Car park')">
                                                </i>
                                                <i class="fas fa-garage cusromGrey p-2" tooltip="Garage"
                                                    *ngIf="hasAmenities(hotel.HotelAmenities, 'Garage')">
                                                </i>

                                            </div>

                                            <!-- <ng-template #noAmenity>
                                                <div class="col-md-8 text-left wht_clr">
                                                    No Amenities Found
                                                </div>
                                            </ng-template> -->

                                        </div>
                                        <div class="col-md-4 col-12 border_left_price mob_hide"
                                            style="text-align: right;">
                                            <h6 class="mob_hide"><strong>Lowest Price</strong>
                                                We found for this Hotel</h6>
                                            <h4 cusromGrey><strong>{{hotel.Price.Currency}} {{hotel.Price.Amount |
                                                number:'1.1-2'}}</strong></h4>
                                            <!-- <p class="cusromGrey">price per night</p> -->
                                                <div *ngIf="hotel.Refundable == true">
                                                    <a class="cancel_msg">Free Cancellation</a>
                                                </div>
                                            <div class="clearfix"></div>
                                            <a class="hotelDetailsBtn" (click)="onBookNow(hotel)"
                                                aria-controls="collapseBasic" style="color: #ffffff;cursor: pointer;">
                                                Book Now
                                            </a>

                                        </div>

                                        <div class="col-md-4 col-12 border_left_price mob_show"
                                            style="text-align: right;">
                                            <div class="row mobile_row">
                                                <div class="col-6 mobile_left">
                                                    <h4 cusromGrey style="margin: 0px;"><strong>{{hotel.Price.Currency}}
                                                            {{hotel.Price.Amount |
                                                                number:'1.1-2'}}</strong></h4>

                                                    <a class="cancel_msg">Free Cancellation</a>
                                                </div>
                                                <div class="col-6 float-right">
                                                    <a class="hotelDetailsBtn" (click)="onBookNow(hotel)"
                                                        aria-controls="collapseBasic"
                                                        style="color: #ffffff;cursor: pointer;">
                                                        Book Now
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!hotels.length" class="row">
                    <div class="col-md-12 col-lg-12 pr-0">
                        <div class="card-body pb-0 no-hotels">
                            <img class="no_hotel_found" src="assets/images/no_flight_found.jpg" alt="" />
                            <p>No Hotels Found!!!</p>
                        </div>
                    </div>
                </div>
                <ngx-loading [show]="loading"
                    [config]="{primaryColour: primaryColour, secondaryColour: secondaryColour, tertiaryColour: primaryColour, backdropBorderRadius: '3px',fullScreenBackdrop:true}"
                    [template]="loadingTemplate"></ngx-loading>
            </div>
        </div>
    </div>
</section> 

<div class="modal hide fade in" data-backdrop="" id="mapview" tabindex="-1" role="dialog">
    <div class="modal-dialog room-dialog" role="dialog">
        <div class="modal-content ">
            <div class="modal-body">
                <div class="modal-header" style="padding:15px 0px;">
                    <h5 class="modal-title" id="exampleModalLongTitle">
                        <div class="htl-top-detail-col">
                            <div>
                                <h2 style="margin-bottom: 0px; font-size:20px; font-weight: 700;">
                                    {{selectedHotel?.HotelName}}</h2>
                                <div class="htpreview adreshotle" style="font-size: 15px;">
                                    {{selectedHotel?.HotelAddress}}
                                </div>

                            </div>
                        </div>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div #mapContainer id="map1" style="width: 100%; height:480px;"></div>
            </div>
        </div>
    </div>
</div>